<template>
  <b-col>
    <b-row align-v="center">
      <b-button
        v-show="!hideCreateUltimateLo"
        variant="outline-primary"
        size="sm"
        class="mr-2 button__create-sub-lo"
        :disabled="disabled"
        @click="showModalSubLearningOutcome = true"
      >
        Create a sub-learning outcome
      </b-button>

      <span v-show="!hideCreateUltimateLo && !hideCreateCriteriaUltimateLo" class="text-dark mr-2"
        >or</span
      >

      <b-button
        v-show="!hideCreateCriteriaUltimateLo"
        variant="outline-primary"
        size="sm"
        class="button__create-criteria"
        :disabled="disabled"
        @click="showModalCriteria = true"
      >
        Create a criteria
      </b-button>
    </b-row>

    <modal-create-or-update-sub-learning-outcome
      :ultimate-learning-outcome="ultimateLearningOutcome"
      :show.sync="showModalSubLearningOutcome"
    />

    <modal-create-or-update-criteria
      :ultimate-learning-outcome="ultimateLearningOutcome"
      :show.sync="showModalCriteria"
    />
  </b-col>
</template>

<script>
import { LearningOutcome } from '@/models/LearningOutcome';
import ModalCreateOrUpdateCriteria from './ModalCreateOrUpdateCriteria';
import ModalCreateOrUpdateSubLearningOutcome from './ModalCreateOrUpdateSubLearningOutcome';

export default {
  components: {
    ModalCreateOrUpdateCriteria,
    ModalCreateOrUpdateSubLearningOutcome
  },
  props: {
    ultimateLearningOutcome: {
      type: LearningOutcome,
      required: true
    },
    disabled: {
      type: [Number, Boolean],
      default: false
    },
    hideCreateUltimateLo: {
      type: Boolean,
      default: false
    },
    hideCreateCriteriaUltimateLo: {
      type: Boolean,
      default: false
    }
  },

  data() {
    return {
      showModalCriteria: false,
      showModalSubLearningOutcome: false
    };
  }
};
</script>
